export function cfgPasswordMinLength(): number {
  return 8;
}

export function cfgFirstNameMinLength(): number {
  return 1;
}

export function cfgLastNameMinLength(): number {
  return 2;
}

export function cfgSecurityAnswerMinLength(): number {
  return 2;
}

export function cfgSecurityQuestionLength(): number {
  return 2;
}

export function cfgFeedbackBodyLength(): { max: number; min: number } {
  return { max: 400, min: 2 };
}

export function cfgFeedbackSubjectLength(): { max: number; min: number } {
  return { max: 50, min: 2 };
}

export function isPlatformButtonEnabled(): boolean {
  return process.env.REACT_APP_NMI_PLATFORM_BUTTON === 'true';
}

export function isLinkInstitutionEnabled(): boolean {
  return process.env.REACT_APP_SHOW_LINK_INSTITUTION === 'true';
}
